module.exports = __webpack_public_path__ + "static/media/Editea_Sorter-magento2.tar.3c16510d.gz";